import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import SectionTitle from "@/components/feature/SectionTitle";

export default function FeaturedSection() {
  const featured = comics.filter((c) => c.featured).slice(0, 3);

  return (
    <section className="section-pad">
      <div className="container-x">
        <SectionTitle
          kicker="Featured"
          title="编辑精选专题"
          desc="编辑部为你精选的高分专题与连载力作，从心动到烧脑，总有一部对上你的口味。"
        />

        <div className="grid gap-4 md:grid-cols-3">
          {featured.map((comic, i) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group relative flex min-h-[300px] flex-col justify-end overflow-hidden rounded-lg"
            >
              <img
                src={comic.cover}
                alt={`编辑精选：${comic.title}韩漫封面`}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
              <div className="relative p-5">
                <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium text-background-50 ${i === 1 ? "bg-accent-500" : "bg-primary-500"}`}>
                  {comic.featured}
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold text-background-50">
                  {comic.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-200">
                  {comic.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-background-50">
                  立即阅读 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}